<template>
  <div class="topMenu">
    <div>
      <div @click="link($event, './index')" class="topMenu__logo">
        <img :src="logoImg" />
      </div>
    </div>
    <div>
      <div v-if="menuBtnStatus === 'hide'" @click="toggleMenu('show')">
        <hamburger-button
          theme="multi-color"
          size="32"
          :fill="['#fff', '#2F88FF', '#FFF', '#43CCF8']"
        />
      </div>
      <div
        class="topMenu__close"
        v-if="menuBtnStatus === 'show'"
        @click="toggleMenu('hide')"
      >
        <error
          theme="filled"
          size="24"
          fill="#ffffff"
          :strokeWidth="1"
          strokeLinejoin="bevel"
          strokeLinecap="butt"
        />
      </div>

      <nav v-if="menuBtnStatus === 'show'" class="topMenu__nav" bg-w>
        <div
          v-for="item in navList"
          :key="item.name"
          @click="link($event, item.path)"
          class="topMenu__navItem"
          fz18
          ph30
          pv18
          color-primary
          :class="{ 'topMenu__navItem--active': item.path === currentPath }"
        >
          {{ item.name }}
        </div>
      </nav>
    </div>
  </div>
</template>
<script>
import logoImg from "@assets/images/web/logo.png";
import { HamburgerButton, Error } from "@icon-park/vue";
export default {
  name: "PTop",
  components: {
    HamburgerButton,
    Error,
  },
  data() {
    return {
      logoImg,
      menuBtnStatus: "hide",
      currentPath: "/web",
      navList: [
        {
          name: "首页",
          path: "./index",
        },
        {
          name: "产品能力",
          path: "./creativity",
        },
        {
          name: "成功案例",
          path: "./list",
        },
        {
          name: "关于我们",
          path: "./about-us",
        },
        {
          name: "直达词",
          path: "./direct-words",
        },
      ],
    };
  },
  watch: {
    $route(to) {
      this.currentPath = to.path;
    },
  },
  mounted() {
    this.currentPath = this.$router.history.current.path;
  },
  methods: {
    toggleMenu(status) {
      this.menuBtnStatus = status;
    },
    link(e, path) {
      // console.log(e);
      window.location.href = path;
      // this.$router.push({ path });
      this.menuBtnStatus = "hide";
    },
  },
};
</script>
<style lang="scss" scoped>
@include b(topMenu) {
  width: 10rem;
  height: 104px;
  background-color: $color-primary;
  padding: 26px 30px 19px 16px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin-left: 50%;
  transform: translateX(-50%);
  @include e(logo) {
    display: block;
    width: 203px;
  }
  @include e(item) {
    display: block;
    line-height: 100%;
    padding: 15px 30px;
    box-sizing: border-box;
  }
  @include e(nav) {
    position: fixed;
    height: calc(100vh - 104px);
    width: 100%;
    left: 0;
    top: 104px;
  }
  @include e(close) {
    margin-right: 20px;
  }
  @include e(navItem) {
    font-size: 32px;
    color: #000000;
    padding: 30px 58px;
    @include m(active) {
      color: $color-text-blue;
    }
  }
}
</style>